import * as Output from "../../Text";

export const postalCode = v => (!v || /^[a-zA-Z\d -]*$/.test(v)
    ? undefined
    : Output.resolve('generic.errors.M010_ValidPostcode'));